// ========================
//  GLOBAL VARIABLES
// ========================
const JSON_URL = window.INVENTORY_JSON_URL;
let allItems = [];
let allColors = new Set();
let allTags = new Set();
const priorityTagList = ["new", "restock", "available online"];
const tagsInfoImages = [
"https://cdn.shopify.com/s/files/1/0912/0582/8925/files/DEFINITIONS_2.webp?v=1783401244"
];
let costCategories = ["Under $10", "$10-$20", "$20-$30", "$30-$40", "$40-$100", "Over $100"];
let inventoryLoaded = false;
const costCategoriesOrdered = ["Under $10", "$10-$20", "$20-$30", "$30-$40", "$40-$100", "Over $100"];
let priceMinIndex = 0;
let priceMaxIndex = costCategoriesOrdered.length - 1;
let priceSliderInitialized = false;

// --- Hardness slider state ---
let hardnessMin = 0;
let hardnessMax = 10;
const hardnessStep = 0.2;
let hardnessSliderInitialized = false;

// --- Size slider state ---
let sizeMin = 0;
let sizeMax = 10;
const sizeStep = 0.5;
let sizeSliderInitialized = false;

// ========================
//  CHAT / REQUEST LOGIC (Stream List version)
// ========================
function showNotification(message, type = 'success') {
  const notification = document.getElementById('inventory-notification');
  const messageEl = document.getElementById('notification-message');
  messageEl.textContent = message;
  notification.className = 'inventory-notification show';
  notification.classList.remove('success', 'error', 'info');
  notification.classList.add(type);
  setTimeout(() => notification.classList.remove('show'), 3000);
}

async function sendMessageToChat(messageText, buttonElement) {
  console.log('📦 Attempting to send inventory request:', messageText);
  const originalText = buttonElement.textContent;
  buttonElement.textContent = 'Sending...';
  buttonElement.disabled = true;

  try {
      const chatInput = document.querySelector('.chat-input');
      const chatForm = document.querySelector('.chat-drawer__inputrow');

      if (!chatInput || !chatForm) {
      throw new Error('Chat elements not found');
      }

      if (typeof window.CHAT_USER !== 'undefined' && !window.CHAT_USER.loggedIn) {
      showLoginPrompt(messageText);
      buttonElement.textContent = originalText;
      buttonElement.disabled = false;
      return false;
      }

      const originalInputValue = chatInput.value;
      const chatDrawer = document.querySelector('.chat-drawer');
      const wasChatOpen = chatDrawer && !chatDrawer.hidden;

      chatInput.value = messageText;
      chatInput.dispatchEvent(new Event('input', { bubbles: true }));
      chatInput.dispatchEvent(new Event('change', { bubbles: true }));

      const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      chatForm.dispatchEvent(submitEvent);

      showNotification('Request sent to chat!', 'success');
      buttonElement.textContent = 'Sent ✓';

      setTimeout(() => {
      if (!wasChatOpen && chatInput.value === messageText) {
          chatInput.value = '';
      }
      }, 100);

      setTimeout(() => {
      buttonElement.textContent = originalText;
      buttonElement.disabled = false;
      }, 2000);

      return true;
  } catch (error) {
      console.error('Error sending message:', error);
      showNotification('Unable to send automatically. Please try again.', 'error');
      buttonElement.textContent = originalText;
      buttonElement.disabled = false;
      return false;
  }
}

function showLoginPrompt(pendingMessage) {
  let modal = document.getElementById('chat-login-modal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    if (pendingMessage) sessionStorage.setItem('pendingInventoryRequest', pendingMessage);
    return;
  }
  const loginButton = document.querySelector('.chat-launcher, .login-button, [href*="/account/login"]');
  if (loginButton) {
    loginButton.click();
    if (pendingMessage) sessionStorage.setItem('pendingInventoryRequest', pendingMessage);
    return;
  }
  if (confirm('You need to be logged in to send inventory requests. Would you like to log in now?')) {
    window.location.href = '/account/login?return_to=' + encodeURIComponent(window.location.pathname);
  }
}

document.addEventListener('inventoryRequestNeedsLogin', function(e) {
  showLoginPrompt(e.detail?.message);
});

function setupInventoryRequestButtons() {
  document.addEventListener('click', async function(e) {
    const requestBtn = e.target.closest('.request-in-chat-btn');
    if (!requestBtn) return;
    e.preventDefault();
    e.stopPropagation();
    const description = requestBtn.dataset.description || '';
    const sku = requestBtn.dataset.sku || '';
    const message = `list ${description} ${sku}`.trim();
    await sendMessageToChat(message, requestBtn);
  });
}

// ========================
//  INVENTORY TOGGLE & FLOATING BUTTON
// ========================
function toggleFloatingCloseButton(show) {
  const floatingBtn = document.getElementById('floating-close-btn');
  if (!floatingBtn) return;
  if (show) {
    floatingBtn.style.display = 'block';
    setTimeout(() => floatingBtn.classList.add('visible'), 10);
  } else {
    floatingBtn.classList.remove('visible');
    setTimeout(() => floatingBtn.style.display = 'none', 300);
  }
}

function scrollToTop() {
  const invSection = document.querySelector('.inventory-viewer-section');
  if (invSection) invSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function toggleInventory(show) {
  const contentEl = document.getElementById('inventory-content');
  const toggleBtn = document.getElementById('inventory-toggle-btn');
  if (show) {
    contentEl.classList.add('loaded');
    toggleBtn.textContent = 'Close Stone List';
    toggleFloatingCloseButton(true);
  } else {
    contentEl.classList.remove('loaded');
    toggleBtn.textContent = 'Stone List';
    toggleFloatingCloseButton(false);
    scrollToTop();
  }
}

document.getElementById('inventory-toggle-btn').addEventListener('click', function() {
  const btn = this;
  const loadingEl = document.getElementById('inventory-loading');
  const contentEl = document.getElementById('inventory-content');
  if (inventoryLoaded) {
    toggleInventory(!contentEl.classList.contains('loaded'));
    return;
  }
  btn.classList.add('loading');
  loadingEl.style.display = 'block';
  loadInventoryData().then(() => {
    btn.classList.remove('loading');
    loadingEl.style.display = 'none';
    toggleInventory(true);
    inventoryLoaded = true;
    setupInventoryRequestButtons();
  }).catch(error => {
    btn.classList.remove('loading');
    loadingEl.innerHTML = '<p>Error loading inventory. Please try again.</p>';
    console.error('Inventory load error:', error);
  });
});

document.getElementById('inventory-close-btn').addEventListener('click', () => toggleInventory(false));

document.addEventListener('click', function(e) {
  const contentEl = document.getElementById('inventory-content');
  const toggleBtn = document.getElementById('inventory-toggle-btn');
  const modalOverlay = document.getElementById('info-modal-overlay');

  if (modalOverlay && modalOverlay.contains(e.target)) {
      return;
  }
  // Also ignore clicks inside the image zoom overlay
  const zoomOverlay = document.getElementById('image-zoom-overlay');
  if (zoomOverlay && zoomOverlay.contains(e.target)) {
      return;
  }

  if (inventoryLoaded && contentEl.classList.contains('loaded') &&
      !contentEl.contains(e.target) && e.target !== toggleBtn) {
      toggleInventory(false);
  }
});

document.getElementById('floating-close-btn')?.addEventListener('click', () => toggleInventory(false));

// ========================
//  HELPER FUNCTIONS
// ========================
const pick = (row, ...keys) => {
  for (const k of keys) if (row[k] != null && String(row[k]).trim() !== '') return String(row[k]);
  return '';
};
const pickNum = (row, ...keys) => {
  for (const k of keys) {
    const v = row[k];
    if (v == null || v === '') continue;
    const n = Number(String(v).replace(/[^0-9.\-]/g,''));
    if (!Number.isNaN(n)) return n;
  }
  return '';
};

function getCostCategory(item) {
  if (item.costRating && typeof item.costRating === 'string') {
    const normalized = item.costRating.trim();
    for (let cat of costCategories) {
      if (normalized.toLowerCase() === cat.toLowerCase()) return cat;
    }
    const simpleMatch = costCategories.find(cat => normalized.includes(cat.replace(/\s/g, '')));
    if (simpleMatch) return simpleMatch;
  }
  const price = item.price;
  if (price !== null && !isNaN(price) && price !== '') {
    const p = parseFloat(price);
    if (p < 10) return "Under $10";
    if (p >= 10 && p < 20) return "$10-$20";
    if (p >= 20 && p < 30) return "$20-$30";
    if (p >= 30 && p < 40) return "$30-$40";
    if (p >= 40 && p < 100) return "$40-$100";
    if (p >= 100) return "Over $100";
  }
  return null;
}

function matchesFilters(item, filters) {
  const searchQuery = filters.search || "";
  if (searchQuery) {
    const searchLower = searchQuery.toLowerCase();
    const searchFields = [
      item.type, item.description, item.locality, item.continent,
      item.notes, item.sku, item.aka, item.tags
    ];
    if (!searchFields.some(field => field && field.toLowerCase().includes(searchLower))) return false;
  }
  if (filters.type && filters.type !== "") {
    if (item.type.toLowerCase() !== filters.type.toLowerCase()) return false;
  }
  if (filters.subtype && filters.subtype !== "") {
    if (!item.subtype || item.subtype.toLowerCase() !== filters.subtype.toLowerCase()) return false;
  }
  if (filters.tags && filters.tags.length) {
    const itemTags = [];
    if (item.tags) {
      itemTags.push(...item.tags.split(',').map(t => t.trim().toLowerCase()));
    }
    if (item.priorityTag && item.priorityTag.toLowerCase() !== 'sold out') {
      itemTags.push(item.priorityTag.toLowerCase());
    }
    if (!filters.tags.every(sel => itemTags.includes(sel.toLowerCase()))) return false;
  }
  if (filters.cost && filters.cost !== "") {
    if (getCostCategory(item) !== filters.cost) return false;
  }
  // Price / cost category filtering
  if (filters.priceRange && !(filters.priceRange.min === 0 && filters.priceRange.max === costCategoriesOrdered.length - 1)) {
    if (item.costIndex === undefined || item.costIndex < 0) return false;
    if (item.costIndex < filters.priceRange.min || item.costIndex > filters.priceRange.max) return false;
  }
  if (filters.colors && filters.colors.length) {
    if (!item.color) return false;
    const itemColors = item.color.toLowerCase().split(/[\/, &]+/).map(c => c.trim());
    if (!filters.colors.some(sel => itemColors.includes(sel))) return false;
  }
    if (filters.sizeRange && !(filters.sizeRange.min === 0 && filters.sizeRange.max === 10)) {
      if (!item.size) return false;
      const s = filters.sizeRange;
      const itemMin = item.size.min;
      const itemMax = item.size.max;
      if (itemMax < s.min || itemMin > s.max) return false;
    }
  // --- Hardness filtering (overlap) ---
  if (filters.hardness && !(filters.hardness.min === 0 && filters.hardness.max === 10)) {
    if (!item.hardness) return false;
    const h = filters.hardness;
    const itemMin = item.hardness.min;
    const itemMax = item.hardness.max;
    if (itemMax < h.min || itemMin > h.max) return false;
  }
  return true;
}

function countMatches(filters) {
  return allItems.filter(item => matchesFilters(item, filters)).length;
}

function updateFilterCounts(currentFilters) {
  // Type filter
  const typeSelect = document.getElementById("type-filter");
  const filtersWithoutType = { ...currentFilters };
  delete filtersWithoutType.type;
  const totalCount = countMatches(filtersWithoutType);
  if (!currentFilters.type) typeSelect.options[0].textContent = `Type (${totalCount})`;
  else typeSelect.options[0].textContent = `Remove Filter (${totalCount})`;
  for (let i = 1; i < typeSelect.options.length; i++) {
    const typeVal = typeSelect.options[i].value;
    const filtersWithType = { ...currentFilters, type: typeVal };
    const count = countMatches(filtersWithType);
    typeSelect.options[i].textContent = `${typeVal} (${count})`;
  }

  // Subtype filter
  const subtypeSelect = document.getElementById("subtype-filter");
  const currentSubtype = subtypeSelect.value;
  if (currentFilters.type && currentFilters.type !== "") {
    const matchingSubtypes = new Set();
    allItems.forEach(item => {
      if (item.type && item.type.toLowerCase() === currentFilters.type.toLowerCase() && item.subtype) {
        matchingSubtypes.add(item.subtype);
      }
    });
    if (matchingSubtypes.size > 0) {
      subtypeSelect.style.display = "inline-block";
      subtypeSelect.innerHTML = '<option value=""></option>';
      subtypeSelect.options[0].textContent = !currentFilters.subtype ? "Subtype" : "Remove Filter";
      Array.from(matchingSubtypes).sort().forEach(subtype => {
        const filtersWithSubtype = { ...currentFilters, subtype: subtype };
        const count = countMatches(filtersWithSubtype);
        const option = document.createElement("option");
        option.value = subtype;
        option.textContent = `${subtype} (${count})`;
        subtypeSelect.appendChild(option);
      });
      if (currentSubtype && matchingSubtypes.has(currentSubtype)) subtypeSelect.value = currentSubtype;
      else subtypeSelect.value = "";
    } else {
      subtypeSelect.style.display = "none";
      subtypeSelect.value = "";
    }
  } else {
    subtypeSelect.style.display = "none";
    subtypeSelect.value = "";
  }

  // Tag filter
  const tagWrapper = document.getElementById("tag-filter-wrapper");
  const tagContainer = document.getElementById("tag-filter");

    // --- Rebuild tag filter dropdown ---
    if (allTags.size > 0) {
      tagWrapper.style.display = "inline-block";
      tagContainer.innerHTML = '';

      // ---- Button row (Remove Filter + More Info) ----
      const btnRow = document.createElement('div');
      btnRow.style.cssText = 'display: flex; gap: 0.5em; justify-content: center; margin-bottom: 0.5em;';

      const clearBtn = document.createElement('button');
      clearBtn.id = 'clear-tags';
      clearBtn.style.cssText = 'padding: 0.3em 0.6em; background: #F4FBDA; border: 1px solid #222; border-radius: 4px; cursor: pointer;';
      clearBtn.textContent = 'Remove Filter';
      clearBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        tagContainer.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.checked = false; });
        applyFilters();
      });

      const moreInfoBtn = document.createElement('button');
      moreInfoBtn.id = 'tags-more-info';
      moreInfoBtn.style.cssText = 'padding: 0.3em 0.6em; background: #F4FBDA; border: 1px solid #222; border-radius: 4px; cursor: pointer;';
      moreInfoBtn.textContent = 'More Info';

      btnRow.appendChild(clearBtn);
      btnRow.appendChild(moreInfoBtn);
      tagContainer.appendChild(btnRow);

      // ---- Split into pinned vs other tags ----
      const allTagsArray = Array.from(allTags).sort();
      const priorityTags = allTagsArray.filter(t => priorityTagList.includes(t));
      const otherTags    = allTagsArray.filter(t => !priorityTagList.includes(t));

      // Pinned section
      if (priorityTags.length > 0) {

        priorityTags.forEach(tag => {
          const id = `tag-${tag.replace(/\s+/g, '-')}`;
          const label = document.createElement('label');
          label.style.display = 'block';
          label.style.marginBottom = '0.3em';
          const cb = document.createElement('input');
          cb.type = 'checkbox';
          cb.name = 'tag-filter';
          cb.value = tag;
          cb.id = id;
          cb.style.marginRight = '0.3em';
          const nameSpan = document.createElement('span');
          nameSpan.textContent = ` ${tag.charAt(0).toUpperCase() + tag.slice(1)} `;
          const countSpan = document.createElement('span');
          countSpan.className = 'tag-count';
          label.appendChild(cb);
          label.appendChild(nameSpan);
          label.appendChild(countSpan);
          tagContainer.appendChild(label);
        });
      }

      // Divider
      const divider = document.createElement('hr');
      divider.style.cssText = 'margin: 0.5em 0; border: none; border-top: 1px solid #222;';
      tagContainer.appendChild(divider);

      // Other tags
      otherTags.forEach(tag => {
        const id = `tag-${tag.replace(/\s+/g, '-')}`;
        const label = document.createElement('label');
        label.style.display = 'block';
        label.style.marginBottom = '0.3em';
        const cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.name = 'tag-filter';
        cb.value = tag;
        cb.id = id;
        cb.style.marginRight = '0.3em';
        const nameSpan = document.createElement('span');
        nameSpan.textContent = ` ${tag.charAt(0).toUpperCase() + tag.slice(1)} `;
        const countSpan = document.createElement('span');
        countSpan.className = 'tag-count';
        label.appendChild(cb);
        label.appendChild(nameSpan);
        label.appendChild(countSpan);
        tagContainer.appendChild(label);
      });

      // Restore checkbox states and update counts
      const currentTagSet = currentFilters.tags || [];
      tagContainer.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        const tag = cb.value;
        cb.checked = currentTagSet.some(t => t.toLowerCase() === tag.toLowerCase());
        const newTags = currentTagSet.some(t => t.toLowerCase() === tag.toLowerCase())
          ? currentTagSet.filter(t => t.toLowerCase() !== tag.toLowerCase())
          : [...currentTagSet, tag.toLowerCase()];
        const count = countMatches({ ...currentFilters, tags: newTags });
        const countSpan = cb.parentElement.querySelector('.tag-count');
        if (countSpan) countSpan.textContent = `(${count})`;
      });
    } else {
      tagWrapper.style.display = "none";
      if (currentFilters.tags) currentFilters.tags = [];
    }

  // Color filter
  const colorContainer = document.getElementById("color-filter");
  colorContainer.innerHTML = '<button id="clear-colors" style="margin-bottom: 0.5em; padding: 0.3em 0.6em; background: #F4FBDA; border: 1px solid #222; border-radius: 4px; cursor: pointer;">Remove Filter</button>';
  Array.from(allColors).sort().forEach(color => {
    const newColors = [...currentFilters.colors];
    if (!newColors.includes(color)) newColors.push(color);
    const filtersWithColor = { ...currentFilters, colors: newColors };
    const count = countMatches(filtersWithColor);
    const id = `color-${color.replace(/\s+/g, '-')}`;
    const label = document.createElement("label");
    label.style.display = "block";
    label.style.marginBottom = "0.3em";
    label.innerHTML = `<input type="checkbox" name="color-filter" value="${color}" id="${id}" style="margin-right: 0.3em;" ${currentFilters.colors.includes(color) ? 'checked' : ''}>${color.charAt(0).toUpperCase() + color.slice(1)} (${count})`;
    colorContainer.appendChild(label);
  });
  document.getElementById("clear-colors")?.addEventListener("click", (e) => {
    e.stopPropagation();
    document.querySelectorAll('input[name="color-filter"]').forEach(cb => cb.checked = false);
    applyFilters();
  });

      // --- Size filter visibility and auto-reset ---
    const sizeWrapper = document.getElementById("size-filter-wrapper");
    if (sizeWrapper) {
      const triggerKeywords = ["beads", "cab", "sphere", "facet", "calibrated", "ring"];
      const shouldShowSize = currentFilters.type && triggerKeywords.some(kw => currentFilters.type.toLowerCase().includes(kw));
      if (shouldShowSize) {
        sizeWrapper.style.display = "inline-block";
      } else {
        sizeWrapper.style.display = "none";
        // If the size filter is active (not default 0-10), reset it
        if (sizeMin !== 0 || sizeMax !== 10) {
          sizeMin = 0;
          sizeMax = 10;
          if (sizeSliderInitialized) {
            // Update the slider handles visually
            const handleMin = document.getElementById('size-handle-min');
            const handleMax = document.getElementById('size-handle-max');
            const trackFill = document.getElementById('size-track-fill');
            if (handleMin && handleMax && trackFill) {
              const container = document.getElementById('size-slider-container');
              if (container && container.clientHeight) {
                const barHeight = container.clientHeight;
                const valueToTop = (val) => (1 - val / 10) * barHeight;
                handleMin.style.top = valueToTop(0) + 'px';
                handleMax.style.top = valueToTop(10) + 'px';
                trackFill.style.top = '0px';
                trackFill.style.height = barHeight + 'px';
                document.getElementById('size-min-val').textContent = '0.0';
                document.getElementById('size-max-val').textContent = '10.0';
              }
            }
          }
          applyFilters(); // re-filter with reset size range
        }
      }
    }
}

function applyFilters() {
  const searchQuery = document.getElementById("search-input").value;
  const typeFilter = document.getElementById("type-filter").value;
  const subtypeFilter = document.getElementById("subtype-filter")?.value || "";
  const selectedTags = Array.from(document.querySelectorAll('#tag-filter input[type="checkbox"]:checked')).map(cb => cb.value.toLowerCase());
  const costFilter = document.getElementById("cost-filter")?.value || "";
  const selectedColors = Array.from(document.querySelectorAll('input[name="color-filter"]:checked')).map(cb => cb.value.toLowerCase());

  const currentFilters = {
    search: searchQuery,
    type: typeFilter,
    subtype: subtypeFilter,
    tags: selectedTags,
    colors: selectedColors,
    priceRange: { min: priceMinIndex, max: priceMaxIndex },
    sizeRange: { min: sizeMin, max: sizeMax },
    hardness: { min: hardnessMin, max: hardnessMax }
  };

  const filteredItems = allItems.filter(item => matchesFilters(item, currentFilters));
  filteredItems.sort((a, b) => a.description.localeCompare(b.description));
  renderItems(filteredItems);
  updateFilterCounts(currentFilters);
}

function renderItems(items) {
  const container = document.getElementById("inventory-list");
  container.innerHTML = "";
  items.forEach(item => {
    const { type, description, continent, locality, sizeDisplay, length, amount, tunnel, notes, fluorescent, imageUrl, additionalImages, priorityTag, price, price2x, sku, link, aka, costRating, tags, color, infoImages, generalInfo, hardness } = item;
    const tagHTML = (priorityTag && priorityTag.toLowerCase() !== "sold out") ? `<span style="color:#FF7F27; font: inherit;"> ${priorityTag}</span>` : '';
    let priceDisplay = '';
    if (price !== null && price !== '' && !isNaN(price)) {
      priceDisplay = `<p><strong>Price:</strong> $${price}</p>`;
    }

    // Format hardness for display
    let hardnessDisplay = '';
    if (hardness) {
      if (hardness.min === hardness.max) {
        hardnessDisplay = `<p><strong>Mohs Hardness:</strong> ${hardness.min}</p>`;
      } else {
        hardnessDisplay = `<p><strong>Mohs Hardness:</strong> ${hardness.min} – ${hardness.max}</p>`;
      }
    }

    const gridRows = [
      { left: priceDisplay, right: price2x ? `<p><strong>Bundle Discount:</strong> ${price2x}</p>` : '' },
      { left: sizeDisplay ? `<p><strong>Size:</strong> ${sizeDisplay}</p>` : '', right: amount ? `<p><strong>Quantity:</strong> ${amount}</p>` : '' },
      { left: length ? `<p><strong>Length:</strong> ${length}</p>` : '', right: tunnel ? `<p><strong>Tunnel Width:</strong> ${tunnel}</p>` : '' },
      { left: color ? `<p><strong>Color:</strong> ${color}</p>` : '', right: sku ? `<p><strong>SKU:</strong> ${sku}</p>` : '' },
      { left: hardnessDisplay, right: '' }
    ];
    const gridHTML = `<div class="detail-grid">${gridRows.map(row => `<div>${row.left}</div><div>${row.right}</div>`).join('')}</div>`;

    const hasMoreInfo = (infoImages && infoImages.length > 0) || (generalInfo && generalInfo.trim() !== '');
    const moreInfoButtonHTML = hasMoreInfo
      ? `<button type="button" class="more-info-btn action-btn">Size & ID Guide</button>`
      : '';

    const collapsedHTML = `
      <div class="collapsed-view">
        ${imageUrl ? `<img src="${imageUrl}" alt="${type}" loading="lazy" />` : ""}
        <span>${description}${tagHTML}</span>
        <button class="request-in-chat-btn collapsed-request-btn"
                data-description="${description}"
                data-sku="${sku || ''}"
                style="margin-left: auto; background: #E4F6A2; color: black; border: 1px solid #96A46B; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.9em;">
          Request
        </button>
      </div>`;

    const expandedHTML = `
      <div class="expanded-view">
        <div>
          <div class="expanded-text-content">
            <p><strong>Type:</strong> ${type}</p>
            ${aka ? `<p><strong>AKA:</strong> ${aka}</p>` : ""}
            ${continent ? `<p><strong>Continent:</strong> ${continent}</p>` : ""}
            ${locality ? `<p><strong>Locality:</strong>${/\|/.test(locality) ? "<br>" : " "}${locality.split("|").map(s=>s.trim()).filter(Boolean).join("<br>")}</p>` : ""}
            ${notes ? `<p><strong>Notes:</strong> ${notes.replace(/\s*\|\s*/g, "<br>")}</p>` : ""}
            ${(() => {
              const hasExactPrice = (price !== null && price !== '' && !isNaN(price)) || 
                                    (price2x !== null && price2x !== '');
              return (!hasExactPrice && costRating) ? `<p><strong>Average Cost:</strong> ${costRating}</p>` : '';
            })()}
            ${tags ? `<p><strong>Tags:</strong> ${tags}</p>` : ""}
            ${fluorescent && fluorescent.toLowerCase().includes("y") ? `<p style="color: purple;"><strong>Fluorescent under UV light!</strong></p>` : ""}
          </div>
          ${gridHTML}
          ${moreInfoButtonHTML}
          ${link ? `<a href="${link}" target="_blank" class="action-btn" style="width: auto; max-width: fit-content;">Purchase Here</a>` : ""}
        </div>
        ${createGallery(item)}
      </div>`;

    const wrapper = document.createElement("div");
    wrapper.classList.add("inventory-item");
    wrapper.innerHTML = collapsedHTML + expandedHTML;
    const collapsed = wrapper.querySelector(".collapsed-view");
    const expanded = wrapper.querySelector(".expanded-view");
    const gallery = expanded.querySelector(".image-gallery");
    collapsed.addEventListener("click", () => {
      document.querySelectorAll(".expanded-view").forEach(view => {
        if (view !== expanded) {
          view.classList.remove("open");
          view.closest('.inventory-item')?.classList.remove('expanded');
        }
      });
      expanded.classList.toggle("open");
      if (expanded.classList.contains("open")) {
        wrapper.classList.add("expanded");
        if (gallery && !gallery.dataset.initialized) {
          setupGallery(gallery);
          gallery.dataset.initialized = "true";
        }
      } else {
        wrapper.classList.remove("expanded");
      }
    });

    // More Info button listener
    const moreInfoBtn = wrapper.querySelector(".more-info-btn");
    if (moreInfoBtn) {
      moreInfoBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        // Prepare text content from generalInfo (same logic as the old modal)
        let textHtml = '';
        const raw = (item.generalInfo || '').trim();
        if (raw !== '') {
          const matches = raw.match(/"([^"]*)"/g);
          let displayText = '';
          if (matches) {
            displayText = matches.map(m => m.slice(1, -1)).join('\n\n');
          } else {
            displayText = raw;
          }
          textHtml = displayText.replace(/\n/g, '<br>');
        }

        if (item.infoImages && item.infoImages.length > 0) {
          openSimpleZoom(item.infoImages, 0, textHtml);
        } else if (textHtml !== '') {
          // If only text, we still open the viewer with just the text (no image)
          openSimpleZoom([], 0, textHtml);
        }
      });
    }

    container.appendChild(wrapper);
  });
}

function createGallery(item) {
  const allImages = [item.imageUrl, ...(item.additionalImages || [])].filter(Boolean);
  if (allImages.length === 0) return '';
  // arrowsOutside = true → arrows render next to (not on top of) the image
  return createGalleryFromUrls(allImages, true);
}

function createGalleryFromUrls(urls, arrowsOutside = false) {
  if (!urls || urls.length === 0) return '';

  const hasArrows = urls.length > 1;
  const leftArrow  = hasArrows ? `<button class="gallery-arrow gallery-arrow-left" aria-label="Previous image">&#10094;</button>` : '';
  const rightArrow = hasArrows ? `<button class="gallery-arrow gallery-arrow-right" aria-label="Next image">&#10095;</button>` : '';

  const imagesHtml = urls.map((url, i) => `
          <img src="${url}" 
               class="gallery-image ${i === 0 ? 'active' : ''}" 
               data-index="${i}"
               loading="${i === 0 ? 'eager' : 'lazy'}"
               aria-hidden="${i !== 0}">`).join('');

  // Left arrow → image strip → right arrow
  const galleryBody = arrowsOutside
    ? `${leftArrow}
       <div class="gallery-images">${imagesHtml}</div>
       ${rightArrow}`
    : `<div class="gallery-images">
         ${leftArrow}
         ${rightArrow}
         ${imagesHtml}
       </div>`;

  return `
    <div class="image-gallery${arrowsOutside && hasArrows ? ' has-arrows' : ''}" data-images='${JSON.stringify(urls)}'>
      ${galleryBody}
      <div class="gallery-indicators">
        ${urls.map((_, i) => `
          <button class="gallery-dot ${i === 0 ? 'active' : ''}" 
                  data-index="${i}"
                  aria-label="View image ${i + 1}"></button>`).join('')}
      </div>
    </div>`;
}

  function setupGallery(gallery) {
    const images = Array.from(gallery.querySelectorAll('.gallery-image'));
    const dots = gallery.querySelectorAll('.gallery-dot');
    const leftArrow = gallery.querySelector('.gallery-arrow-left');
    const rightArrow = gallery.querySelector('.gallery-arrow-right');
    let currentIndex = 0;
    let isAnimating = false;
    let multiTouch = false;

    images.forEach((img, i) => {
      img.style.transform = i === 0 ? 'translateX(0%)' : 'translateX(100%)';
      if (i === 0) img.classList.add('active');
    });

    gallery.addEventListener('touchstart', e => {
      if (isAnimating) return;
      multiTouch = e.touches.length > 1;
      if (!multiTouch) {
        startX = e.touches[0].clientX;
      }
    }, { passive: true });

    gallery.addEventListener('touchmove', e => {
      if (e.touches.length > 1) {
        multiTouch = true;
      }
    }, { passive: true });

    gallery.addEventListener('touchend', e => {
      if (isAnimating || multiTouch) return;
      const diffX = e.changedTouches[0].clientX - startX;
      if (Math.abs(diffX) > 70) {
        if (diffX > 0 && currentIndex > 0) {
          showImage(currentIndex - 1, 'right');
        } else if (diffX < 0 && currentIndex < images.length - 1) {
          showImage(currentIndex + 1, 'left');
        }
      }
      multiTouch = false;
    }, { passive: true });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        if (isAnimating) return;
        const targetIndex = parseInt(dot.dataset.index);
        const direction = targetIndex > currentIndex ? 'left' : 'right';
        showImage(targetIndex, direction);
      });
    });

    if (leftArrow) {
        leftArrow.addEventListener('click', () => {
            if (isAnimating || currentIndex === 0) return;
            showImage(currentIndex - 1, 'right');
        });
        }
        if (rightArrow) {
        rightArrow.addEventListener('click', () => {
            if (isAnimating || currentIndex === images.length - 1) return;
            showImage(currentIndex + 1, 'left');
        });
    }

    function showImage(index, direction) {
      if (index === currentIndex || isAnimating) return;
      isAnimating = true;

      const currentImg = images[currentIndex];
      const nextImg = images[index];

      images.forEach(img => {
        img.classList.remove("active", "slide-out-left", "slide-out-right", "slide-in-left", "slide-in-right");
      });

      nextImg.style.transform = direction === "left" ? "translateX(100%)" : "translateX(-100%)";
      void nextImg.offsetWidth;
      currentImg.style.transform = direction === "left" ? "translateX(-100%)" : "translateX(100%)";
      nextImg.style.transform = "translateX(0%)";
      nextImg.classList.add("active");

      setTimeout(() => {
        dots[currentIndex].classList.remove("active");
        dots[index].classList.add("active");
        currentIndex = index;
        isAnimating = false;
      }, 400);
    }
  }
// ========================
//  MODAL LOGIC
// ========================
function openModal(item) {
  const overlay = document.getElementById("info-modal-overlay");
  const body = document.getElementById("info-modal-body");
  body.innerHTML = '';

  if (item.generalInfo && item.generalInfo.trim() !== '') {
    const raw = item.generalInfo.trim();
    const matches = raw.match(/"([^"]*)"/g);
    let displayText = '';
    if (matches) {
      displayText = matches.map(m => m.slice(1, -1)).join('\n\n');
    } else {
      displayText = raw;
    }
    const textDiv = document.createElement('div');
    textDiv.className = 'info-modal-text';
    textDiv.innerHTML = displayText.replace(/\n/g, '<br>');
    body.appendChild(textDiv);
  }

  if (item.infoImages && item.infoImages.length > 0) {
    const galleryHTML = createGalleryFromUrls(item.infoImages);
    const galleryContainer = document.createElement('div');
    galleryContainer.innerHTML = galleryHTML;
    body.appendChild(galleryContainer);
    const gallery = galleryContainer.querySelector('.image-gallery');
    if (gallery) {
      setTimeout(() => setupGallery(gallery), 50);
    }
  }

  overlay.classList.add('active');
}

function openHardnessInfoModal() {
  const overlay = document.getElementById('info-modal-overlay');
  const body = document.getElementById('info-modal-body');
  body.innerHTML = '';

  const img = document.createElement('img');
  img.src = 'https://cdn.shopify.com/s/files/1/0912/0582/8925/files/Mohs.png?v=1783994281';
  img.alt = 'Hardness Info';
  img.style.maxWidth = '100%';
  img.style.maxHeight = '80vh';
  img.style.display = 'block';
  img.style.margin = '0 auto';
  body.appendChild(img);

  overlay.classList.add('active');
}

function openTagsInfoModal() {
  const overlay = document.getElementById('info-modal-overlay');
  const body = document.getElementById('info-modal-body');
  body.innerHTML = '';

  if (tagsInfoImages.length > 0) {
    const galleryHTML = createGalleryFromUrls(tagsInfoImages);
    const galleryContainer = document.createElement('div');
    galleryContainer.innerHTML = galleryHTML;
    body.appendChild(galleryContainer);
    const gallery = galleryContainer.querySelector('.image-gallery');
    if (gallery) {
      setTimeout(() => setupGallery(gallery), 50);
    }
  } else {
    const textDiv = document.createElement('div');
    textDiv.className = 'info-modal-text';
    textDiv.textContent = 'No additional tag information available.';
    body.appendChild(textDiv);
  }
  overlay.classList.add('active');
}

function closeModal() {
  const overlay = document.getElementById("info-modal-overlay");
  overlay.classList.remove('active');
  document.getElementById("info-modal-body").innerHTML = '';
}

document.getElementById("info-modal-close").addEventListener("click", closeModal);
document.getElementById("info-modal-overlay").addEventListener("click", function(e) {
  if (e.target === this) closeModal();
});
document.addEventListener("keydown", function(e) {
  if (e.key === "Escape" && document.getElementById("info-modal-overlay").classList.contains("active")) {
    closeModal();
  }
});

// ========================
//  IMAGE ZOOM LOGIC
// ========================
let zoomUrls = [];
let zoomIndex = 0;
let zoomState = { scale: 1, translateX: 0, translateY: 0 };

function clampTranslation(img, scale, tx, ty) {
  const naturalW = img.naturalWidth * scale;
  const naturalH = img.naturalHeight * scale;
  const containerW = img.parentElement.clientWidth;
  const containerH = img.parentElement.clientHeight;
  const maxTx = Math.max(0, (naturalW - containerW) / 2);
  const maxTy = Math.max(0, (naturalH - containerH) / 2);
  tx = Math.min(maxTx, Math.max(-maxTx, tx));
  ty = Math.min(maxTy, Math.max(-maxTy, ty));
  return { tx, ty };
}

function openImageZoom(urls, startIndex) {
  const overlay = document.getElementById('image-zoom-overlay');
  const img = document.getElementById('image-zoom-img');
  const resetBtn = document.getElementById('image-zoom-reset');
  const prevBtn = document.getElementById('zoom-prev');
  const nextBtn = document.getElementById('zoom-next');

  zoomUrls = urls;
  zoomIndex = startIndex;

  if (urls.length > 1) {
    prevBtn.style.display = 'block';
    nextBtn.style.display = 'block';
  } else {
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
  }

  img.src = urls[zoomIndex];
  zoomState = { scale: 1, translateX: 0, translateY: 0 };
  img.style.transform = 'translate(0px, 0px) scale(1)';
  resetBtn.classList.remove('visible');
  overlay.classList.add('active');

  setupZoomInteractions();
}

function setupZoomInteractions() {
  const overlay = document.getElementById('image-zoom-overlay');
  const container = document.getElementById('image-zoom-container');
  const img = document.getElementById('image-zoom-img');
  const resetBtn = document.getElementById('image-zoom-reset');

  let isPanning = false;
  let startX, startY, startTranslateX, startTranslateY;
  let initialPinchDistance = 0;
  let pinchStartScale = 1;
  let pinchStartTranslateX = 0, pinchStartTranslateY = 0;

  function updateTransform() {
    const { tx, ty } = clampTranslation(img, zoomState.scale, zoomState.translateX, zoomState.translateY);
    zoomState.translateX = tx;
    zoomState.translateY = ty;
    img.style.transform = `translate(${tx}px, ${ty}px) scale(${zoomState.scale})`;
    resetBtn.classList.toggle('visible', zoomState.scale !== 1 || tx !== 0 || ty !== 0);
  }

  function onWheel(e) {
    e.preventDefault();
    const rect = img.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const oldScale = zoomState.scale;
    const zoomSpeed = 0.1;
    if (e.deltaY < 0) zoomState.scale = Math.min(zoomState.scale + zoomSpeed, 5);
    else zoomState.scale = Math.max(zoomState.scale - zoomSpeed, 0.5);
    const scaleChange = zoomState.scale / oldScale;
    zoomState.translateX = mouseX - scaleChange * (mouseX - zoomState.translateX);
    zoomState.translateY = mouseY - scaleChange * (mouseY - zoomState.translateY);
    updateTransform();
  }

  function onPointerDown(e) {
    if (e.pointerType === 'touch' && e.isPrimary && e.target === img) {
      isPanning = true;
      startX = e.clientX;
      startY = e.clientY;
      startTranslateX = zoomState.translateX;
      startTranslateY = zoomState.translateY;
      img.setPointerCapture(e.pointerId);
    } else if (e.pointerType === 'mouse') {
      isPanning = true;
      startX = e.clientX;
      startY = e.clientY;
      startTranslateX = zoomState.translateX;
      startTranslateY = zoomState.translateY;
      img.setPointerCapture(e.pointerId);
    }
  }

  function onPointerMove(e) {
    if (!isPanning) return;
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    zoomState.translateX = startTranslateX + dx;
    zoomState.translateY = startTranslateY + dy;
    updateTransform();
  }

  function onPointerUp(e) {
    isPanning = false;
    if (img.hasPointerCapture(e.pointerId)) img.releasePointerCapture(e.pointerId);
  }

  function onTouchStart(e) {
    if (e.touches.length === 2) {
      isPanning = false;
      initialPinchDistance = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      pinchStartScale = zoomState.scale;
      pinchStartTranslateX = zoomState.translateX;
      pinchStartTranslateY = zoomState.translateY;
    }
  }

  function onTouchMove(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      const currentDistance = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      if (initialPinchDistance > 0) {
        const newScale = Math.min(5, Math.max(0.5, pinchStartScale * (currentDistance / initialPinchDistance)));
        const scaleChange = newScale / pinchStartScale;
        const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        const containerRect = container.getBoundingClientRect();
        const imgLeft = containerRect.left + zoomState.translateX;
        const imgTop = containerRect.top + zoomState.translateY;
        const pointX = (midX - imgLeft) / pinchStartScale;
        const pointY = (midY - imgTop) / pinchStartScale;
        zoomState.scale = newScale;
        zoomState.translateX = midX - containerRect.left - pointX * newScale;
        zoomState.translateY = midY - containerRect.top - pointY * newScale;
        updateTransform();
      }
    }
  }

  function onTouchEnd(e) {
    if (e.touches.length < 2) initialPinchDistance = 0;
  }

  function onDoubleClick(e) {
    zoomState = { scale: 1, translateX: 0, translateY: 0 };
    updateTransform();
  }

  if (overlay._zoomCleanup) overlay._zoomCleanup();
  container.addEventListener('wheel', onWheel, { passive: false });
  container.addEventListener('pointerdown', onPointerDown);
  container.addEventListener('pointermove', onPointerMove);
  container.addEventListener('pointerup', onPointerUp);
  container.addEventListener('pointercancel', onPointerUp);
  container.addEventListener('touchstart', onTouchStart, { passive: false });
  container.addEventListener('touchmove', onTouchMove, { passive: false });
  container.addEventListener('touchend', onTouchEnd);
  container.addEventListener('dblclick', onDoubleClick);

  overlay._zoomCleanup = () => {
    container.removeEventListener('wheel', onWheel);
    container.removeEventListener('pointerdown', onPointerDown);
    container.removeEventListener('pointermove', onPointerMove);
    container.removeEventListener('pointerup', onPointerUp);
    container.removeEventListener('pointercancel', onPointerUp);
    container.removeEventListener('touchstart', onTouchStart);
    container.removeEventListener('touchmove', onTouchMove);
    container.removeEventListener('touchend', onTouchEnd);
    container.removeEventListener('dblclick', onDoubleClick);
  };
}

function closeImageZoom() {
  const overlay = document.getElementById('image-zoom-overlay');
  if (overlay._zoomCleanup) {
    overlay._zoomCleanup();
    overlay._zoomCleanup = null;
  }
  overlay.classList.remove('active');
}

function goToZoomImage(newIndex) {
  if (newIndex < 0 || newIndex >= zoomUrls.length) return;
  zoomIndex = newIndex;
  const img = document.getElementById('image-zoom-img');
  img.src = zoomUrls[zoomIndex];
  zoomState = { scale: 1, translateX: 0, translateY: 0 };
  img.style.transform = 'translate(0px, 0px) scale(1)';
  document.getElementById('image-zoom-reset').classList.remove('visible');
}

document.getElementById('zoom-prev').addEventListener('click', () => goToZoomImage(zoomIndex - 1));
document.getElementById('zoom-next').addEventListener('click', () => goToZoomImage(zoomIndex + 1));

document.getElementById('image-zoom-close').addEventListener('click', closeImageZoom);
document.getElementById('image-zoom-overlay').addEventListener('click', function(e) {
  if (e.target === this || e.target.id === 'image-zoom-container') {
    closeImageZoom();
  }
});
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && document.getElementById('image-zoom-overlay').classList.contains('active')) {
    closeImageZoom();
  }
});

document.getElementById('image-zoom-reset').addEventListener('click', function() {
  zoomState = { scale: 1, translateX: 0, translateY: 0 };
  const img = document.getElementById('image-zoom-img');
  img.style.transform = 'translate(0px, 0px) scale(1)';
  this.classList.remove('visible');
});

// ----- Desktop click-to-zoom on gallery images -----
document.getElementById('inventory-list').addEventListener('click', function(e) {
  if (e.pointerType !== 'mouse') return;
  const galleryImage = e.target.closest('.gallery-image');
  if (!galleryImage) return;
  const gallery = galleryImage.closest('.image-gallery');
  if (!gallery) return;
  const urls = JSON.parse(gallery.dataset.images);
  const clickedIndex = parseInt(galleryImage.dataset.index, 10);
  if (urls && urls.length > 0) {
    e.stopPropagation();
    openImageZoom(urls, clickedIndex);
  }
});

  function initPriceSlider() {
    if (priceSliderInitialized) return;
    const container = document.getElementById('price-slider-container');
    if (!container) return;
    if (container.clientHeight === 0) container.style.height = '280px';

    ['price-handle-min', 'price-handle-max', 'price-track-fill', 'price-track-bg'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.style.display = 'block';
    });

    const trackFill = document.getElementById('price-track-fill');
    const handleMin = document.getElementById('price-handle-min');
    const handleMax = document.getElementById('price-handle-max');
    const resetBtn = document.getElementById('price-reset');
    const numCategories = costCategoriesOrdered.length;
    const sliderMax = numCategories - 1; // 5

    function valueToTop(val) {
      const barHeight = container.clientHeight;
      return (1 - val / sliderMax) * barHeight;
    }
    function topToValue(top) {
      const barHeight = container.clientHeight;
      let val = (1 - top / barHeight) * sliderMax;
      val = Math.round(val);
      return Math.max(0, Math.min(sliderMax, val));
    }

    function updateUI(min, max, fromCode) {
      handleMin.style.top = valueToTop(min) + 'px';
      handleMax.style.top = valueToTop(max) + 'px';
      const topMin = valueToTop(min);
      const topMax = valueToTop(max);
      trackFill.style.top = Math.min(topMin, topMax) + 'px';
      trackFill.style.height = Math.abs(topMax - topMin) + 'px';
      if (!fromCode) {
        priceMinIndex = min;
        priceMaxIndex = max;
        applyFilters();
      }
    }

    function handleDragStart(e) {
      e.preventDefault();
      const handle = e.target;
      handle.setPointerCapture(e.pointerId);
      handle.addEventListener('pointermove', handleDragMove);
      handle.addEventListener('pointerup', handleDragEnd);
      handle.addEventListener('pointercancel', handleDragEnd);
    }
    function handleDragMove(e) {
      if (!e.pointerId) return;
      const handle = e.target;
      const rect = container.getBoundingClientRect();
      const topRelative = e.clientY - rect.top;
      let newVal = topToValue(topRelative);
      if (handle === handleMin) {
        if (newVal > priceMaxIndex) newVal = priceMaxIndex;
        updateUI(newVal, priceMaxIndex, true);
      } else {
        if (newVal < priceMinIndex) newVal = priceMinIndex;
        updateUI(priceMinIndex, newVal, true);
      }
    }
    function handleDragEnd(e) {
      const handle = e.target;
      handle.removeEventListener('pointermove', handleDragMove);
      handle.removeEventListener('pointerup', handleDragEnd);
      handle.removeEventListener('pointercancel', handleDragEnd);
      if (handle === handleMin) {
        const rect = container.getBoundingClientRect();
        const topRelative = (e.clientY || e.changedTouches?.[0]?.clientY) - rect.top;
        let newVal = topToValue(topRelative);
        if (newVal > priceMaxIndex) newVal = priceMaxIndex;
        priceMinIndex = newVal;
      } else {
        const rect = container.getBoundingClientRect();
        const topRelative = (e.clientY || e.changedTouches?.[0]?.clientY) - rect.top;
        let newVal = topToValue(topRelative);
        if (newVal < priceMinIndex) newVal = priceMinIndex;
        priceMaxIndex = newVal;
      }
      applyFilters();
    }

    container.addEventListener('pointerdown', (e) => {
      if (e.target.classList.contains('price-handle')) return;
      const rect = container.getBoundingClientRect();
      const topRelative = e.clientY - rect.top;
      const clickVal = topToValue(topRelative);
      const distMin = Math.abs(clickVal - priceMinIndex);
      const distMax = Math.abs(clickVal - priceMaxIndex);
      if (distMin <= distMax) {
        priceMinIndex = clickVal;
        if (priceMinIndex > priceMaxIndex) priceMinIndex = priceMaxIndex;
      } else {
        priceMaxIndex = clickVal;
        if (priceMaxIndex < priceMinIndex) priceMaxIndex = priceMinIndex;
      }
      updateUI(priceMinIndex, priceMaxIndex, false);
    });

    handleMin.addEventListener('pointerdown', handleDragStart);
    handleMax.addEventListener('pointerdown', handleDragStart);

    resetBtn.addEventListener('click', () => {
      priceMinIndex = 0;
      priceMaxIndex = sliderMax;
      updateUI(0, sliderMax, false);
    });

    updateUI(priceMinIndex, priceMaxIndex, true);
    priceSliderInitialized = true;
  }
// ========================
//  HARDNESS SLIDER LOGIC
// ========================
function initHardnessSlider() {
  if (hardnessSliderInitialized) return;
  const container = document.getElementById('hardness-slider-container');
  if (!container) return;

  if (container.clientHeight === 0) {
    container.style.height = '280px';
  }

  ['hardness-handle-min', 'hardness-handle-max', 'hardness-track-fill', 'hardness-track-bg'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.style.display = 'block';
  });

  const trackFill = document.getElementById('hardness-track-fill');
  const handleMin = document.getElementById('hardness-handle-min');
  const handleMax = document.getElementById('hardness-handle-max');
  const minValSpan = document.getElementById('hardness-min-val');
  const maxValSpan = document.getElementById('hardness-max-val');
  const resetBtn = document.getElementById('hardness-reset');

  function valueToTop(val) {
    const barHeight = container.clientHeight;
    return (1 - val / 10) * barHeight;
  }

  function topToValue(top) {
    const barHeight = container.clientHeight;
    let val = (1 - top / barHeight) * 10;
    val = Math.round(val / hardnessStep) * hardnessStep;
    return Math.max(0, Math.min(10, val));
  }

  function updateUI(min, max, fromCode) {
    handleMin.style.top = valueToTop(min) + 'px';
    handleMax.style.top = valueToTop(max) + 'px';
    const topMin = valueToTop(min);
    const topMax = valueToTop(max);
    trackFill.style.top = Math.min(topMin, topMax) + 'px';
    trackFill.style.height = Math.abs(topMax - topMin) + 'px';
    minValSpan.textContent = min.toFixed(1);
    maxValSpan.textContent = max.toFixed(1);
    if (!fromCode) {
      hardnessMin = min;
      hardnessMax = max;
      applyFilters();
    }
  }

  function handleDragStart(e) {
    e.preventDefault();
    const handle = e.target;
    handle.setPointerCapture(e.pointerId);
    handle.addEventListener('pointermove', handleDragMove);
    handle.addEventListener('pointerup', handleDragEnd);
    handle.addEventListener('pointercancel', handleDragEnd);
  }

  function handleDragMove(e) {
    if (!e.pointerId) return;
    const handle = e.target;
    const rect = container.getBoundingClientRect();
    const clientY = e.clientY;
    const topRelative = clientY - rect.top;
    let newVal = topToValue(topRelative);
    if (handle === handleMin) {
      if (newVal > hardnessMax) newVal = hardnessMax;
      updateUI(newVal, hardnessMax, true);
    } else {
      if (newVal < hardnessMin) newVal = hardnessMin;
      updateUI(hardnessMin, newVal, true);
    }
  }

  function handleDragEnd(e) {
    const handle = e.target;
    handle.removeEventListener('pointermove', handleDragMove);
    handle.removeEventListener('pointerup', handleDragEnd);
    handle.removeEventListener('pointercancel', handleDragEnd);
    if (handle === handleMin) {
      const rect = container.getBoundingClientRect();
      const topRelative = (e.clientY || e.changedTouches?.[0]?.clientY) - rect.top;
      let newVal = topToValue(topRelative);
      if (newVal > hardnessMax) newVal = hardnessMax;
      hardnessMin = newVal;
    } else {
      const rect = container.getBoundingClientRect();
      const topRelative = (e.clientY || e.changedTouches?.[0]?.clientY) - rect.top;
      let newVal = topToValue(topRelative);
      if (newVal < hardnessMin) newVal = hardnessMin;
      hardnessMax = newVal;
    }
    applyFilters();
  }

  container.addEventListener('pointerdown', (e) => {
    if (e.target.classList.contains('hardness-handle')) return;
    const rect = container.getBoundingClientRect();
    const topRelative = e.clientY - rect.top;
    const clickVal = topToValue(topRelative);
    const distMin = Math.abs(clickVal - hardnessMin);
    const distMax = Math.abs(clickVal - hardnessMax);
    if (distMin <= distMax) {
      hardnessMin = clickVal;
      if (hardnessMin > hardnessMax) hardnessMin = hardnessMax;
    } else {
      hardnessMax = clickVal;
      if (hardnessMax < hardnessMin) hardnessMax = hardnessMin;
    }
    updateUI(hardnessMin, hardnessMax, false);
  });

  handleMin.addEventListener('pointerdown', handleDragStart);
  handleMax.addEventListener('pointerdown', handleDragStart);

  resetBtn.addEventListener('click', () => {
    hardnessMin = 0;
    hardnessMax = 10;
    updateUI(0, 10, false);
  });

  updateUI(0, 10, true);
  hardnessSliderInitialized = true;
}
  // --- Size slider logic (full) ---
  function initSizeSlider() {
    if (sizeSliderInitialized) return;
    const container = document.getElementById('size-slider-container');
    if (!container) return;
    if (container.clientHeight === 0) {
      container.style.height = '280px';
    }
    ['size-handle-min', 'size-handle-max', 'size-track-fill', 'size-track-bg'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.style.display = 'block';
    });

    const trackFill = document.getElementById('size-track-fill');
    const handleMin = document.getElementById('size-handle-min');
    const handleMax = document.getElementById('size-handle-max');
    const minValSpan = document.getElementById('size-min-val');
    const maxValSpan = document.getElementById('size-max-val');
    const resetBtn = document.getElementById('size-reset');
    const SLIDER_MAX = 10;

    function valueToTop(val) {
      const barHeight = container.clientHeight;
      return (1 - val / SLIDER_MAX) * barHeight;
    }
    function topToValue(top) {
      const barHeight = container.clientHeight;
      let val = (1 - top / barHeight) * SLIDER_MAX;
      val = Math.round(val / sizeStep) * sizeStep;
      return Math.max(0, Math.min(SLIDER_MAX, val));
    }

    function updateUI(min, max, fromCode) {
      handleMin.style.top = valueToTop(min) + 'px';
      handleMax.style.top = valueToTop(max) + 'px';
      const topMin = valueToTop(min);
      const topMax = valueToTop(max);
      trackFill.style.top = Math.min(topMin, topMax) + 'px';
      trackFill.style.height = Math.abs(topMax - topMin) + 'px';
      minValSpan.textContent = min.toFixed(1);
      maxValSpan.textContent = max.toFixed(1);
      if (!fromCode) {
        sizeMin = min;
        sizeMax = max;
        applyFilters();
      }
    }

    function handleDragStart(e) {
      e.preventDefault();
      const handle = e.target;
      handle.setPointerCapture(e.pointerId);
      handle.addEventListener('pointermove', handleDragMove);
      handle.addEventListener('pointerup', handleDragEnd);
      handle.addEventListener('pointercancel', handleDragEnd);
    }

    function handleDragMove(e) {
      if (!e.pointerId) return;
      const handle = e.target;
      const rect = container.getBoundingClientRect();
      const clientY = e.clientY;
      const topRelative = clientY - rect.top;
      let newVal = topToValue(topRelative);
      if (handle === handleMin) {
        if (newVal > sizeMax) newVal = sizeMax;
        updateUI(newVal, sizeMax, true);
      } else {
        if (newVal < sizeMin) newVal = sizeMin;
        updateUI(sizeMin, newVal, true);
      }
    }

    function handleDragEnd(e) {
      const handle = e.target;
      handle.removeEventListener('pointermove', handleDragMove);
      handle.removeEventListener('pointerup', handleDragEnd);
      handle.removeEventListener('pointercancel', handleDragEnd);
      if (handle === handleMin) {
        const rect = container.getBoundingClientRect();
        const topRelative = (e.clientY || e.changedTouches?.[0]?.clientY) - rect.top;
        let newVal = topToValue(topRelative);
        if (newVal > sizeMax) newVal = sizeMax;
        sizeMin = newVal;
      } else {
        const rect = container.getBoundingClientRect();
        const topRelative = (e.clientY || e.changedTouches?.[0]?.clientY) - rect.top;
        let newVal = topToValue(topRelative);
        if (newVal < sizeMin) newVal = sizeMin;
        sizeMax = newVal;
      }
      applyFilters();
    }

    container.addEventListener('pointerdown', (e) => {
      if (e.target.classList.contains('size-handle')) return;
      const rect = container.getBoundingClientRect();
      const topRelative = e.clientY - rect.top;
      const clickVal = topToValue(topRelative);
      const distMin = Math.abs(clickVal - sizeMin);
      const distMax = Math.abs(clickVal - sizeMax);
      if (distMin <= distMax) {
        sizeMin = clickVal;
        if (sizeMin > sizeMax) sizeMin = sizeMax;
      } else {
        sizeMax = clickVal;
        if (sizeMax < sizeMin) sizeMax = sizeMin;
      }
      updateUI(sizeMin, sizeMax, false);
    });

    handleMin.addEventListener('pointerdown', handleDragStart);
    handleMax.addEventListener('pointerdown', handleDragStart);

    resetBtn.addEventListener('click', () => {
      sizeMin = 0;
      sizeMax = SLIDER_MAX;
      updateUI(0, SLIDER_MAX, false);
    });

    updateUI(0, SLIDER_MAX, true);
    sizeSliderInitialized = true;
  }
// ========================
//  INITIAL DATA LOAD
// ========================
function loadInventoryData() {
  return fetch(JSON_URL, { cache: 'no-store' })
    .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(({ rows = [] }) => {
      if (!rows.length) { console.warn('No rows in JSON'); allItems = []; return; }
      allColors.clear();
      allTags.clear();

      // Build raw items – keep sold‑out entries for variant processing
      const rawItems = rows.map(r => {
        const sku          = pick(r,'sku','SKU','id');
        const type         = pick(r,'type','Type','category');
        if (!type) return null;

        const subtype      = pick(r,'subype','subtype','SubType','Subtype');
        const description  = pick(r,'description','Description','desc');
        const locality     = pick(r,'locality','Locality','location');
        const continent    = pick(r,'continent','Continent','region');
        const notes        = pick(r,'notes','Notes');
        const priorityTag  = pick(r,'status','priorityTag','PriorityTag','priority','tag');
        const sizeRaw = pick(r,'approxize','size','Size');
        let sizeRange = null;
        if (sizeRaw) {
          const cleaned = sizeRaw.replace(/mm/gi, '').trim();
          const parts = cleaned.split('-');
          if (parts.length === 2) {
            const sMin = parseFloat(parts[0]);
            const sMax = parseFloat(parts[1]);
            if (!isNaN(sMin) && !isNaN(sMax)) {
              sizeRange = { min: Math.min(sMin, sMax), max: Math.max(sMin, sMax) };
            }
          } else {
            const val = parseFloat(cleaned);
            if (!isNaN(val)) sizeRange = { min: val, max: val };
          }
        }
        const sizeDisplay = sizeRaw || '';
        const length       = pick(r,'approxength','length','Length');
        const amount       = pick(r,'approx','amount','Amount','qty','quantity');
        const tunnel       = pick(r,'approxunnelize','tunnel','Tunnel');
        const color        = pick(r,'color','Color','colour');
        const price        = pickNum(r,'price','Price');
        const price2x      = pick(r,'x2rice','price2x','Price2x','x2Price','x2price','bundlerice','bundleprice');
        const fluorescent  = pick(r,'fluorescent','Fluorescent','uv','UV');
        const imageUrl     = pick(r,'image1','imageUrl','image','primaryImage');
        const additionalImg1 = pick(r,'image2','additionalImg1','image_2');
        const additionalImg2 = pick(r,'image3','additionalImg2','image_3');
        const additionalImg3 = pick(r,'image4','additionalImg3','image_4');
        const link         = pick(r,'link','Link','productLink','url');
        const aka          = pick(r,'aka','AKA','alias','also_known_as');
        const costRating   = pick(r, 'costating', 'cost_rating', 'Cost Rating', 'costrating', 'costRating');
        let tags           = pick(r,'tags','Tags','tag');
        const cat = getCostCategory({ costRating, price });
        let costIndex = cat ? costCategoriesOrdered.indexOf(cat) : -1;

        // If the item has a purchase link, add the “Available Online” tag
        if (link) {
          tags = tags ? `${tags}, Available Online` : "Available Online";
        }

        // hardness
        const hardnessRaw  = pick(r, 'hardness', 'Hardness', 'mohs', 'Mohs', 'mohsHardness');
        let hardness = null;
        if (hardnessRaw) {
          const parts = hardnessRaw.split('-').map(s => s.trim());
          if (parts.length === 2) {
            const hMin = parseFloat(parts[0]);
            const hMax = parseFloat(parts[1]);
            if (!isNaN(hMin) && !isNaN(hMax)) {
              hardness = { min: Math.min(hMin, hMax), max: Math.max(hMin, hMax) };
            }
          } else {
            const val = parseFloat(hardnessRaw);
            if (!isNaN(val)) {
              hardness = { min: val, max: val };
            }
          }
        }

        // Info Images and General Info
        const infoImagesRaw = pick(r, 'infomage', 'infoImages', 'info_images', 'InfoImages', 'Info Images');
        const infoImages = infoImagesRaw ? infoImagesRaw.split(/\s+/).filter(token => token.startsWith('http')) : [];
        const generalInfoRaw = pick(r, 'generalnfo', 'generalInfo', 'general_info', 'GeneralInfo', 'info', 'General Info');
        const generalInfo = generalInfoRaw ? generalInfoRaw.trim() : '';

        return {
          sku, type, subtype, description, continent, locality,
          notes, priorityTag,
          size: sizeRange,
          sizeDisplay: sizeDisplay,
          length, amount, tunnel,
          color, price, price2x, fluorescent,
          costIndex,
          imageUrl,
          additionalImages: [additionalImg1, additionalImg2, additionalImg3].filter(Boolean),
          link, aka, costRating, tags,
          infoImages, generalInfo,
          hardness
        };
      }).filter(Boolean);

      // --- Variant grouping & primary resolution ---
      const groups = new Map();
      rawItems.forEach(item => {
        const desc = (item.description || '').trim().toLowerCase();
        if (!groups.has(desc)) groups.set(desc, []);
        groups.get(desc).push(item);
      });

      groups.forEach((items, desc) => {
        if (items.length === 1) {
          const item = items[0];
          if (item.priorityTag && item.priorityTag.toLowerCase() === 'sold out') {
            item.link = null;
            item.priorityTag = 'Sold Out';
          }
          return;
        }

        let primary = items[0];
        for (let i = 1; i < items.length; i++) {
          const curr = items[i];
          if (curr.sku.length < primary.sku.length) {
            primary = curr;
          } else if (curr.sku.length === primary.sku.length && curr.sku < primary.sku) {
            primary = curr;
          }
        }

        items.forEach(item => {
          if (item !== primary) item.isVariant = true;
        });

        const availableItem = items.find(
          item => (!item.priorityTag || item.priorityTag.toLowerCase() !== 'sold out') && item.link
        ) || items.find(
          item => !item.priorityTag || item.priorityTag.toLowerCase() !== 'sold out'
        );

        if (availableItem) {
          primary.link = availableItem.link || null;
          primary.priorityTag = (availableItem.priorityTag && availableItem.priorityTag.toLowerCase() !== 'sold out')
            ? availableItem.priorityTag
            : null;
        } else {
          primary.link = null;
          primary.priorityTag = 'Sold Out';
        }
      });

      // Build final item list – exclude variants and sold-out primaries
      allItems = rawItems.filter(item => !item.isVariant);
      allItems = allItems.filter(item => !item.priorityTag || item.priorityTag.toLowerCase() !== 'sold out');

      // Populate global color/tag sets from final items
      allItems.forEach(item => {
        if (item.color) {
          item.color.split(/[\/, &]+/).map(c => c.trim()).filter(Boolean).forEach(c => allColors.add(c.toLowerCase()));
        }
        let combinedTags = item.tags ? item.tags : '';
        if (item.priorityTag && item.priorityTag.toLowerCase() !== 'sold out') {
          combinedTags = combinedTags ? `${combinedTags}, ${item.priorityTag}` : item.priorityTag;
        }
        if (combinedTags) {
          combinedTags.split(',').forEach(t => {
            const trimmed = t.trim().toLowerCase();
            if (trimmed) allTags.add(trimmed);
          });
        }
      });

      // Populate type filter
      const typeSelect = document.getElementById("type-filter");
      typeSelect.innerHTML = '<option value="">Type</option>';
      const typeSet = new Set();
      allItems.forEach(item => { if (item.type) typeSet.add(item.type); });
      Array.from(typeSet).sort().forEach(value => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = value;
        typeSelect.appendChild(option);
      });

      // Set up filter event listeners
      document.getElementById("search-input").addEventListener("input", applyFilters);
      document.getElementById("type-filter").addEventListener("change", applyFilters);
      document.getElementById("subtype-filter").addEventListener("change", applyFilters);
      document.getElementById("color-filter").addEventListener("change", applyFilters);

      // Color toggle
      const colorToggle = document.getElementById("color-toggle");
      const colorMenu = document.getElementById("color-filter");
      const colorWrapper = document.getElementById("color-filter-wrapper");
      if (colorToggle && colorMenu && colorWrapper) {
        colorToggle.addEventListener("click", () => {
          colorMenu.style.display = colorMenu.style.display === "block" ? "none" : "block";
        });
        document.addEventListener("click", e => {
          if (!colorWrapper.contains(e.target)) colorMenu.style.display = "none";
        });
      }

      // Tag toggle & checkboxes
      const tagToggle = document.getElementById("tag-toggle");
      const tagMenu = document.getElementById("tag-filter");
      const tagWrapper = document.getElementById("tag-filter-wrapper");
      if (tagToggle && tagMenu && tagWrapper) {
        tagToggle.addEventListener("click", () => {
          tagMenu.style.display = tagMenu.style.display === "block" ? "none" : "block";
        });
        document.addEventListener("click", e => {
          if (!tagWrapper.contains(e.target)) tagMenu.style.display = "none";
        });
      }
      document.getElementById("tag-filter").addEventListener("change", applyFilters);

      // Delegate click for tags "More Info" button
      document.getElementById("tag-filter").addEventListener("click", function(e) {
        if (e.target && e.target.id === "tags-more-info") {
          e.stopPropagation();
          openSimpleZoom(tagsInfoImages, 0);
        }
      });

      // Mohs hardness toggle & init
      const mohsToggle = document.getElementById("mohs-toggle");
      const mohsMenu = document.getElementById("mohs-filter");
      const mohsWrapper = document.getElementById("mohs-filter-wrapper");
      if (mohsToggle && mohsMenu && mohsWrapper) {
        mohsToggle.addEventListener("click", () => {
          const isCurrentlyHidden = mohsMenu.style.display !== "block";
          mohsMenu.style.display = isCurrentlyHidden ? "block" : "none";
          if (isCurrentlyHidden) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                initHardnessSlider();
              });
            });
          }
        });
        document.addEventListener("click", e => {
          if (!mohsWrapper.contains(e.target)) mohsMenu.style.display = "none";
        });
      }

      // Hardness More Info button
      document.getElementById('hardness-more-info').addEventListener('click', () => {
        const hardnessImage = 'https://cdn.shopify.com/s/files/1/0912/0582/8925/files/Mohs.png?v=1783994281';
        openSimpleZoom([hardnessImage], 0);
      });

      // Size toggle & init
      const sizeToggle = document.getElementById("size-toggle");
      const sizeMenu = document.getElementById("size-filter");
      const sizeWrapper = document.getElementById("size-filter-wrapper");
      if (sizeToggle && sizeMenu && sizeWrapper) {
        sizeToggle.addEventListener("click", () => {
          const isCurrentlyHidden = sizeMenu.style.display !== "block";
          sizeMenu.style.display = isCurrentlyHidden ? "block" : "none";
          if (isCurrentlyHidden) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                initSizeSlider();
              });
            });
          }
        });
        document.addEventListener("click", e => {
          if (!sizeWrapper.contains(e.target)) sizeMenu.style.display = "none";
        });
      }

      // Price toggle & init
      const priceToggle = document.getElementById("price-toggle");
      const priceMenu = document.getElementById("price-filter");
      const priceWrapper = document.getElementById("price-filter-wrapper");
      if (priceToggle && priceMenu && priceWrapper) {
        priceToggle.addEventListener("click", () => {
          const isCurrentlyHidden = priceMenu.style.display !== "block";
          priceMenu.style.display = isCurrentlyHidden ? "block" : "none";
          if (isCurrentlyHidden) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                initPriceSlider();
              });
            });
          }
        });
        document.addEventListener("click", e => {
          if (!priceWrapper.contains(e.target)) priceMenu.style.display = "none";
        });
      }

      applyFilters(); // initial render
    });
}

(function() {
  const overlay = document.getElementById('simple-zoom-overlay');
  const container = document.getElementById('simple-zoom-container');
  const img = document.getElementById('simple-zoom-img');
  const resetBtn = document.getElementById('simple-zoom-reset');
  const closeBtn = document.getElementById('simple-zoom-close');
  const prevBtn = document.getElementById('simple-zoom-prev');
  const nextBtn = document.getElementById('simple-zoom-next');
  const textDiv = document.getElementById('simple-zoom-text');

  let state = { scale: 1, translateX: 0, translateY: 0 };
  let isDragging = false;
  let dragStart = { x: 0, y: 0, translateX: 0, translateY: 0 };

  // Image list and current index
  let imageUrls = [];
  let currentIndex = 0;

  // Base dimensions of the image when scale=1 and centered
  let baseW = 1, baseH = 1, offsetX = 0, offsetY = 0;

  // Touch pinch state
  let initialPinchDistance = 0;
  let pinchStartScale = 1;
  let pinchStartTranslateX = 0, pinchStartTranslateY = 0;

  // ---- Clamping using measured base dimensions ----
  function clamp(sc, tx, ty) {
    const renderedW = baseW * sc;
    const renderedH = baseH * sc;
    const containerW = container.clientWidth;
    const containerH = container.clientHeight;

    const effLeft = offsetX + tx;
    const effTop = offsetY + ty;

    const minLeft = containerW - renderedW;
    const maxLeft = 0;
    const minTop = containerH - renderedH;
    const maxTop = 0;

    let clampedLeft = Math.min(maxLeft, Math.max(minLeft, effLeft));
    let clampedTop = Math.min(maxTop, Math.max(minTop, effTop));

    if (renderedW <= containerW) clampedLeft = (containerW - renderedW) / 2;
    if (renderedH <= containerH) clampedTop = (containerH - renderedH) / 2;

    return {
      tx: clampedLeft - offsetX,
      ty: clampedTop - offsetY
    };
  }

  function applyTransform() {
    const { tx, ty } = clamp(state.scale, state.translateX, state.translateY);
    state.translateX = tx;
    state.translateY = ty;
    img.style.transform = `translate(${tx}px, ${ty}px) scale(${state.scale})`;
    const isDefault = (state.scale === 1 && tx === 0 && ty === 0);
    resetBtn.classList.toggle('visible', !isDefault);
  }

  function resetView() {
    state = { scale: 1, translateX: 0, translateY: 0 };
    applyTransform();
  }

  function captureBaseDimensions() {
    const imgRect = img.getBoundingClientRect();
    const contRect = container.getBoundingClientRect();
    baseW = imgRect.width;
    baseH = imgRect.height;
    offsetX = imgRect.left - contRect.left;
    offsetY = imgRect.top - contRect.top;
  }

  // ---- Show a specific image (by index) ----
  function showImage(index) {
    if (!imageUrls.length) return;
    currentIndex = index;
    img.src = imageUrls[currentIndex];
    state = { scale: 1, translateX: 0, translateY: 0 };
    img.style.transform = 'translate(0px, 0px) scale(1)';
    resetBtn.classList.remove('visible');

    // Update arrow visibility
    if (imageUrls.length > 1) {
      prevBtn.style.display = 'block';
      nextBtn.style.display = 'block';
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    img.onload = function() {
      requestAnimationFrame(() => {
        captureBaseDimensions();
        applyTransform();
      });
    };
  }

  // ---- Public: open the viewer ----
  window.openSimpleZoom = function(urls, startIndex, textHtml) {
    if (!urls || urls.length === 0) return;
    imageUrls = urls.slice();
    currentIndex = startIndex || 0;

    // Text content
    if (textHtml && textHtml.trim() !== '') {
      textDiv.innerHTML = textHtml;
      textDiv.style.display = 'block';
    } else {
      textDiv.style.display = 'none';
      textDiv.innerHTML = '';
    }

    showImage(currentIndex);
    overlay.classList.add('active');
  };

  function closeViewer() {
    overlay.classList.remove('active');
    img.src = '';
    imageUrls = [];
    currentIndex = 0;
  }

  closeBtn.addEventListener('click', closeViewer);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeViewer();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('active')) {
      closeViewer();
    }
  });

  // ---- Navigation arrows ----
  prevBtn.addEventListener('click', () => {
    if (currentIndex > 0) showImage(currentIndex - 1);
  });
  nextBtn.addEventListener('click', () => {
    if (currentIndex < imageUrls.length - 1) showImage(currentIndex + 1);
  });

  // ---- Mouse wheel zoom (centered on cursor) ----
  container.addEventListener('wheel', function(e) {
    e.preventDefault();
    const rect = img.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const oldScale = state.scale;
    const zoomSpeed = 0.1;
    if (e.deltaY < 0) {
      state.scale = Math.min(state.scale + zoomSpeed, 5);
    } else {
      state.scale = Math.max(state.scale - zoomSpeed, 0.5);
    }

    const scaleChange = state.scale / oldScale;
    state.translateX = mouseX - scaleChange * (mouseX - state.translateX);
    state.translateY = mouseY - scaleChange * (mouseY - state.translateY);

    applyTransform();
  }, { passive: false });

  // ---- Pointer events (mouse & single-touch drag) ----
  function onPointerDown(e) {
    if (e.pointerType === 'touch' && !e.isPrimary) return; // ignore non-primary touches
    // For two-finger gestures we'll handle pinch separately
    e.preventDefault();
    isDragging = true;
    dragStart.x = e.clientX;
    dragStart.y = e.clientY;
    dragStart.translateX = state.translateX;
    dragStart.translateY = state.translateY;
    img.setPointerCapture(e.pointerId);
  }

  function onPointerMove(e) {
    if (!isDragging) return;
    const dx = e.clientX - dragStart.x;
    const dy = e.clientY - dragStart.y;
    state.translateX = dragStart.translateX + dx;
    state.translateY = dragStart.translateY + dy;
    applyTransform();
  }

  function onPointerUp(e) {
    isDragging = false;
    img.releasePointerCapture(e.pointerId);
  }

  img.addEventListener('pointerdown', onPointerDown);
  img.addEventListener('pointermove', onPointerMove);
  img.addEventListener('pointerup', onPointerUp);
  img.addEventListener('pointercancel', onPointerUp);

  // ---- Pinch-to-zoom (touch) ----
  container.addEventListener('touchstart', function(e) {
    if (e.touches.length === 2) {
      // Stop dragging when pinch starts
      isDragging = false;
      initialPinchDistance = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      pinchStartScale = state.scale;
      pinchStartTranslateX = state.translateX;
      pinchStartTranslateY = state.translateY;
    }
  }, { passive: false });

  container.addEventListener('touchmove', function(e) {
    if (e.touches.length === 2) {
      e.preventDefault();  // prevent browser zoom
      const currentDistance = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      if (initialPinchDistance > 0) {
        const newScale = Math.min(5, Math.max(0.5, pinchStartScale * (currentDistance / initialPinchDistance)));
        const scaleChange = newScale / pinchStartScale;

        // Midpoint between the two fingers
        const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

        // Adjust translation to keep the midpoint stationary
        const rect = container.getBoundingClientRect();
        const pointX = (midX - rect.left - offsetX - pinchStartTranslateX) / pinchStartScale;
        const pointY = (midY - rect.top - offsetY - pinchStartTranslateY) / pinchStartScale;

        state.scale = newScale;
        state.translateX = midX - rect.left - offsetX - pointX * newScale;
        state.translateY = midY - rect.top - offsetY - pointY * newScale;

        applyTransform();
      }
    }
  }, { passive: false });

  container.addEventListener('touchend', function(e) {
    if (e.touches.length < 2) {
      initialPinchDistance = 0;
    }
  });

  // Double-click/tap reset
  img.addEventListener('dblclick', function(e) {
    e.preventDefault();
    resetView();
  });

  resetBtn.addEventListener('click', resetView);
})();